import { render } from "./ExtraMetric.vue?vue&type=template&id=4394b4a1&scoped=true"
import script from "./ExtraMetric.vue?vue&type=script&lang=js"
export * from "./ExtraMetric.vue?vue&type=script&lang=js"

import "./ExtraMetric.vue?vue&type=style&index=0&id=4394b4a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4394b4a1"]])

export default __exports__